/* eslint-disable no-undef */
import React from "react";
import ProductSvg from '../../public/myproducts.svg';
import EventsSvg from '../../public/totalevents.svg';
import { showLoading } from 'react-global-loading';
import UserService from '../../services/UserService';
import Modal from 'react-modal';
export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
class Noifications extends React.Component {
  constructor(props) {
    super(props);
    showLoading(true);
    this.state = {
      expandSidebar: false,
      eventData: [],
      productsData: [],
      filteredEvents: [],
      filteredProducts: [],
      docsData: [],
      users: [],
      schemes: [],
      eventPending: '',
      docApproved: '',
      docPending: '',
      eventApproved: '',
      productApproved: '',
      productPending: '',
      practitioner: [], page: 1, statusType: 1, showModal: false, modalData: {}
    };
  }

  componentDidMount = () => {


    this.getNotifications();

  };

  getNotifications = () => {
    UserService.getNotifications()
      .then((result) => {
        if (!result) return;
        this.setState({ notiData: result.data });
        showLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  }


  onNotiClick = (noti) => {
    // UserService.updateNoti({ 'id': noti.id })
    //   .then((result) => {
    //     if (!result) return;


    switch (noti.type) {
      case 'event':
        this.props.history.push({

          pathname: "/mission-event-detail",
          search: `?id=${noti.post_id}`

        })
        break;
      case 'product':
        this.props.history.push({

          pathname: "/mission-products-detail",
          search: `?id=${noti.post_id}`

        })
        break;
      case 'document':
        this.setState({ showModal: true })
        // this.state.docsData.data.filter(item => item.ID === noti.post_id).map(selectedData => (
        this.setState({ modalData: noti })
        // ));
        break;
      case 'scheme':
        this.setState({ showModal: true, modalData: noti })
        break;

    }
    // })
    // .catch((err) => {
    //   console.error(err);
    // });
  }
  render() {
    const { notiData, schemes, practitioner, productsData, eventData, docsData, showModal, modalData } = this.state;

    return (

      <div className="row p-2 mt-5 mb-3 rounded rounded-2">
        <div className="col-12">
          <ul className="nav nav-tabs alleventtabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button className="nav-link active t1" id="notifications-tab" data-bs-toggle="tab" data-bs-target="#notifications-pane" type="button" role="tab" aria-controls="notifications-pane" aria-selected="true">Notifications</button>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div className="tab-pane fade show active" id="notifications-pane" role="tabpanel" aria-labelledby="notifications-pane" >
              <div className="row mt-4 m-ver-col">
                <div className="col-12 mb-4 m-note">
                  <div className="fw-normal show-count t2 ">Important and General Notifications regarding your practitioner account from Ministry of Ayush</div>
                </div>

                {notiData?.length > 0 ? notiData?.map((item, index) =>                
                <div className="col-lg-4 col-sm-6 col-12 mb-4">
        <div className="card bg-light h-100" onClick={() => this.onNotiClick(item)}>
          <div className="card-body pb-0">            
            <div className="d-flex gap-3 align-items-start">
              {/* Icon */}
            <div className="icon-lg bg-white text-primary rounded-circle mb-4 mt-n5">
            <img src={item.post_type === 'products' && ProductSvg ||
                          item.post_type === 'events' && EventsSvg ||
                          item.post_type === 'documents' && ProductSvg ||
                          item.post_type === 'schemes' && ProductSvg
                        } className="float-end" alt="my events" />
            </div>
            <div>
            {/* Content */}
            <h6 className="text-dark">{item.content}</h6>
            <p>{item.title}</p>
            </div>
            </div>
          </div>          
        </div>
      </div>) : < h3 > No updates</h3>}
              </div>
            </div>

          </div>
        </div>

        <Modal
          isOpen={showModal}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content bg-white p-3">
              <div className="modal-header">
                <h1 className="modal-title fs-5 w-100" id="docapprovalLabel">
                  {modalData.title}
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => this.setState({ showModal: false })}
                  // data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">

                <div className="row mt-2 pdfht" aria-labelledby="#label1">
                  <object
                    id="#label1"
                    width="100%"
                    height="100%"
                    type="application/pdf"
                    data={modalData.document_upload}
                  />
                </div>
              </div>
            </div>
          </div>

        </Modal>
      </div >

    );
  }
}

export default Noifications;
